import { YES_OPTION } from "../constants";
import { formatYesNoDropdownLists } from "../utils/form-data-utils";

export const formatOtherDataFormValues = (associate, language = "pt") => {
    if(typeof associate.otherData.businessOwner !== 'object' && associate.otherData.businessOwner !== null) {
        associate.otherData.businessOwner = formatYesNoDropdownLists(associate.otherData.businessOwner, language);
    }
    else if (typeof associate.otherData.businessOwner === 'object' && associate.otherData.businessOwner !== null) {
        associate.otherData.businessOwner = formatYesNoDropdownLists(associate.otherData.businessOwner.code === YES_OPTION.code, language);
    }

    associate.otherData.hasManagementRole = formatYesNoDropdownLists(associate.otherData.managementRoles.length > 0, language);

    for (let i = 0; i < associate.otherData.managementRoles.length; i++) {
        associate.otherData.managementRoles[i].beginDate = associate.otherData.managementRoles[i].beginDate !== null ? new Date(associate.otherData.managementRoles[i].beginDate) : null;
        associate.otherData.managementRoles[i].endDate = associate.otherData.managementRoles[i].endDate !== null ? new Date(associate.otherData.managementRoles[i].endDate) : null;
    }

    associate.otherData.hasPublicAdminRole = formatYesNoDropdownLists(associate.otherData.publicAdminRoles.length > 0, language);

    for (let i = 0; i < associate.otherData.publicAdminRoles.length; i++) {
        associate.otherData.publicAdminRoles[i].beginDate = associate.otherData.publicAdminRoles[i].beginDate !== null ? new Date(associate.otherData.publicAdminRoles[i].beginDate) : null;
        associate.otherData.publicAdminRoles[i].endDate = associate.otherData.publicAdminRoles[i].endDate !== null ? new Date(associate.otherData.publicAdminRoles[i].endDate) : null;
    }

    associate.otherData.hasQualityCommitteRole = formatYesNoDropdownLists(associate.otherData.qualityCommitteRoles.length > 0, language);

    for (let i = 0; i < associate.otherData.qualityCommitteRoles.length; i++) {
        associate.otherData.qualityCommitteRoles[i].beginDate = associate.otherData.qualityCommitteRoles[i].beginDate !== null ? new Date(associate.otherData.qualityCommitteRoles[i].beginDate) : null;
        associate.otherData.qualityCommitteRoles[i].endDate = associate.otherData.qualityCommitteRoles[i].endDate !== null ? new Date(associate.otherData.qualityCommitteRoles[i].endDate) : null;
    }

    associate.otherData.hasEthicsCommitteeRole = formatYesNoDropdownLists(associate.otherData.ethicsCommitteeRoles.length > 0, language);

    for (let i = 0; i < associate.otherData.ethicsCommitteeRoles.length; i++) {
        associate.otherData.ethicsCommitteeRoles[i].beginDate = associate.otherData.ethicsCommitteeRoles[i].beginDate !== null ? new Date(associate.otherData.ethicsCommitteeRoles[i].beginDate) : null;
        associate.otherData.ethicsCommitteeRoles[i].endDate = associate.otherData.ethicsCommitteeRoles[i].endDate !== null ? new Date(associate.otherData.ethicsCommitteeRoles[i].endDate) : null;
    }

    associate.otherData.hasOrganizationalRole = formatYesNoDropdownLists(associate.otherData.organizationalRoles.length > 0, language);

    for (let i = 0; i < associate.otherData.organizationalRoles.length; i++) {
        associate.otherData.organizationalRoles[i].beginDate = associate.otherData.organizationalRoles[i].beginDate !== null ? new Date(associate.otherData.organizationalRoles[i].beginDate) : null;
        associate.otherData.organizationalRoles[i].endDate = associate.otherData.organizationalRoles[i].endDate !== null ? new Date(associate.otherData.organizationalRoles[i].endDate) : null;
    }

    return associate;
}

export const formatOtherDataToService = (associate) => { 

    associate.otherData.businessOwner = (associate.otherData.businessOwner.code === YES_OPTION.code);
    associate.otherData.professionalsNumber = Number(associate.otherData.professionalsNumber);

    for (let i = 0; i < associate.otherData.managementRoles.length; i++) {
        associate.otherData.managementRoles[i].professionalsNumber = Number(associate.otherData.managementRoles[i].professionalsNumber);
    }

    associate.otherData.hasManagementRole = (associate.otherData.managementRoles.length > 0);
    associate.otherData.hasPublicAdminRole = (associate.otherData.publicAdminRoles.length > 0);
    associate.otherData.hasEthicsCommitteeRole = (associate.otherData.ethicsCommitteeRoles.length > 0);
    associate.otherData.hasQualityCommitteRole = (associate.otherData.qualityCommitteRoles.length > 0);
    associate.otherData.hasOrganizationalRole = (associate.otherData.organizationalRoles.length > 0);

    return associate;
}